// src/pages/shop-settings-tabs/DeliveryTab.jsx
import React from 'react';
import DeliverySettingsCard from '../../components/settings/DeliverySettingsCard';
import PaymentSettingsCard from '../../components/settings/PaymentSettingsCard';
import POSCheckoutSettingsCard from '../../components/settings/POSCheckoutSettingsCard';
import KhrRateCard from '../../components/settings/KhrRateCard';

const DeliveryTab = ({ settings, updateField, toggleField }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <div className="space-y-6">
      <KhrRateCard rate={settings.khr_rate} onChange={v => updateField('khr_rate', v)} />
    </div>
    <div className="lg:col-span-2 space-y-6">
      <DeliverySettingsCard settings={settings} onToggle={toggleField} onChange={updateField} />
      <PaymentSettingsCard settings={settings} onToggle={toggleField} />
      <POSCheckoutSettingsCard settings={settings} onToggle={toggleField} />
    </div>
  </div>
);

export default DeliveryTab;